var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FFF3EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7246 15.8008L19.9996 20.0091L27.2746 15.8008",
    stroke: "#FF6F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 28.4V20",
    stroke: "#FF6F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 23.3329V16.6663C27.4997 16.374 27.4225 16.0869 27.2763 15.8339C27.13 15.5809 26.9198 15.3707 26.6667 15.2246L20.8333 11.8913C20.58 11.745 20.2926 11.668 20 11.668C19.7074 11.668 19.42 11.745 19.1667 11.8913L13.3333 15.2246C13.0802 15.3707 12.87 15.5809 12.7237 15.8339C12.5775 16.0869 12.5003 16.374 12.5 16.6663V23.3329C12.5003 23.6252 12.5775 23.9123 12.7237 24.1653C12.87 24.4183 13.0802 24.6285 13.3333 24.7746L19.1667 28.1079C19.42 28.2542 19.7074 28.3312 20 28.3312C20.2926 28.3312 20.58 28.2542 20.8333 28.1079L26.6667 24.7746C26.9198 24.6285 27.13 24.4183 27.2763 24.1653C27.4225 23.9123 27.4997 23.6252 27.5 23.3329Z",
    stroke: "#2F3567",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalOrder);
export default __webpack_public_path__ + "static/media/totalOrder.69d210920eaba13868ee7b9c797a635c.svg";
export { ForwardRef as ReactComponent };